import React, { useState } from 'react';
import { useAppSelector } from '../../hooks/useAppStore';
import { selectSettings } from '../../store/slices/settingsSlice';

export const AnnouncementBanner: React.FC = () => {
  const settings = useAppSelector(selectSettings);
  const [dismissed, setDismissed] = useState(false);

  if (!settings?.announcementActive || !settings.announcement || dismissed) return null;

  return (
    <div className="w-full bg-yellow/10 border-b border-yellow/20 px-4 py-2 flex items-center justify-between gap-3">
      <p className="text-yellow text-xs font-medium text-center flex-1">{settings.announcement}</p>
      <button
        onClick={() => setDismissed(true)}
        className="text-yellow/60 hover:text-yellow transition-colors flex-shrink-0 text-lg leading-none"
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
};
